import React, { Component, Fragment } from "react";
import {
  BarChart,
  Bar,
  Tooltip,
  ResponsiveContainer,
  YAxis,
  XAxis,
} from "recharts";

import {
  CustomizedXAxisTick,
  StandardTooltip,
  selectFormat,
  Error,
} from "./../../../Utils/Utils.js";

class ReturnFrequency extends Component {
  componentDidMount() {
    this.props.childRef(this);
  }

  getExportData = () => ({
    data: this.props.data.graph,
    opts: {
      type: "chart",
      date: { name: "name", title: "Visits", no_date: true },
      exclude: ["name"],
    },
  });

  render() {
    const { data } = this.props;

    if (data.hasData === false) {
      return <Error minHeight={400} />;
    }

    return (
      <ResponsiveContainer height={400}>
        <BarChart
          data={data.graph}
          layout="vertical"
          margin={{ top: 10, right: 0, left: 0, bottom: 10 }}
        >
          <Tooltip
            cursor={{ fill: "#eee", opacity: 0.5 }}
            content={
              <StandardTooltip
                render={({ data }) => {
                  const payload = data(this.props);
                  if (payload !== null) {
                    return (
                      <div className="standard-tooltip">
                        {Object.keys(payload).map((key) => (
                          <Fragment key={key}>
                            <header className="standard-tooltip__header">
                              <span className="standard-tooltip__key-header">
                                Visits:
                              </span>
                              <span className="standard-tooltip__value-heade">
                                {payload[key].payload.name}
                              </span>
                            </header>
                            <main className="standard-tooltip__main">
                              <div className="standard-tooltip__item">
                                <span className="standard-tooltip__key">
                                  <span
                                    className="standard-tooltip__icon"
                                    style={{ background: "#FA6E57" }}
                                  />
                                  Visitors
                                </span>
                                <span className="standard-tooltip__value">
                                  {selectFormat("number", payload[key].value)}
                                </span>
                              </div>
                            </main>
                          </Fragment>
                        ))}
                      </div>
                    );
                  }
                }}
              />
            }
          />
          <XAxis
            type="number"
            axisLine={false}
            tickLine={false}
            mirror={false}
            dataKey="value"
            tick={<CustomizedXAxisTick />}
          />
          <YAxis
            type="category"
            axisLine={false}
            tickLine={false}
            mirror={false}
            dataKey="name"
          />

          <Bar dataKey="value" fill="#eb5b57" />
        </BarChart>
      </ResponsiveContainer>
    );
  }
}

export default ReturnFrequency;
